export const PaginationKeys = { BillingPayments: 'BillingPayments' };

export const SET_PAGINATION = 'SET_PAGINATION';

export const setPagination =
  ({ target, location }) =>
  (dispatch) => {
    dispatch({ type: SET_PAGINATION, payload: { target, location } });
  };
